import { Card, SearchInput } from '@bp/ui-components';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDebounceCallback } from 'usehooks-ts';
import { CardPicker } from '../CardPicker/CardPicker';
import { useTeachingBlockStore } from '../Contexts/TeachingBlockContext';
import styles from './GridActionArea.module.scss';

export const GridActionArea: FC = observer(() => {
  const { t } = useTranslation();

  const store = useTeachingBlockStore();

  const [searchString, setSearchString] = useState<string>('');
  const setSearchDebounced = useDebounceCallback((value: string) => store.setCardSearchString(value), 200);

  const headline = t('pinboard.showSelectionFor', { type: getSelectionType() });

  const selection = store.selectedRows
    .map((row) => row.label)
    .sort()
    .join(', ');

  function getSelectionType() {
    switch (store.gridContext) {
      case 'classes':
        return t('classes.title', { count: 1 });
      case 'teachers':
        return t('persons.title', { count: 2 });
      default:
        break;
    }
  }

  return (
    <Card
      className={styles['grid-action-area']}
      wrapperClass={classNames(styles.wrapper)}
      contentPadding='none'
      fitContent
    >
      <div className={styles.header}>
        <div className={styles.selection}>
          <div className={styles['board-context']}>{selection ? headline : ''}</div>
          <div className={styles['selected-rows']}>{selection}</div>
        </div>
        <div className={styles.actions}>
          <SearchInput
            name='search-string'
            isOnWhite
            value={searchString}
            onChange={(event) => {
              setSearchString(event.target.value);
              setSearchDebounced(event.target.value);
            }}
            placeholder={t('pinboard.actions.searchCards')}
            className={styles['search-input']}
          />
        </div>
      </div>
      <CardPicker />
    </Card>
  );
});
